import React, { Component } from 'react'
import PlanTop from './PlanTop'
import PlanBottom from './PlanBottom'
import './style.css'

export default class Plan extends Component {

    state = {
        isPjt : true
    }

    menuFx_1 = () => {

        if(this.state.isPjt) {
        
            return
        
        } else {
        
            this.setState({ isPjt : true })

        }
    }

    
    menuFx_2 = () => {

        if(!this.state.isPjt) {
        
            return
        
        } else {
        
            this.setState(
                { isPjt : false }
            )
        }
    }


    render() {

        const selected = {
            background: '#AE9A8A',
            border: '1px solid #AE9A8A'
        }
            
        const unSelected = {
            background: 'none',
            border: 'none'
        }


		return (

            <div className='RegContainer'>

                <div id='PlanTitle'>

                    <span onClick={this.menuFx_1} style={this.state.isPjt ? selected : unSelected }>Mustom</span>
                    <span onClick={this.menuFx_2} style={this.state.isPjt ? unSelected : selected }>PJTP</span>
                
                </div>

                <div id='PlanWrapper'>
                
                    <PlanTop isPjt = {this.state.isPjt} />
                    <PlanBottom isPjt = {this.state.isPjt} />
                
                </div>

            </div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/components/plan/index.js